<template>
  <div>
    <div class="content-block">
      <div class="avatar">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path class="avatar__bg" d="M12 24A12 12 0 0 1 0 12 12 12 0 0 1 12 0a12 12 0 0 1 12 12 12 12 0 0 1-12 12z"/>
          <circle fill="#FFE1A4" cx="6.2" cy="12.1" r="1.5"/>
          <circle fill="#FFE1A4" cx="17.8" cy="12.1" r="1.5"/>
          <path fill="#FFE1A4" d="M6.2 8.2H18v8.7H6.2z"/>
          <path fill="#50360e" d="M18.5 16.3c0-.5-.2-.9-.5-1.2V9.9c-.8 0-1.5.7-1.5 1.5v2.4c0 .5-.3.7-.7.7H8.4c-.5 0-.7-.3-.7-.7v-2.4c0-.8-.7-1.5-1.5-1.5v4.9c-.5.3-.7.8-.7 1.3 0 .8.6 1.5 1.4 1.7v.1c0 1.2 1 2.2 2.2 2.2l.7-.1c.4.7 1.1 1.3 2 1.3a2 2 0 0 0 1.9-1.2c.3.2.7.3 1.1.3a2 2 0 0 0 2-2v-.3c.9 0 1.7-.8 1.7-1.8z"/>
          <path fill="#14243a" d="M12 17.6c.7 0 1.2-.5 1.4-1.1.1-.2-.1-.5-.4-.5h-2.1c-.2 0-.5.2-.4.5.3.8.8 1.1 1.5 1.1z"/>
          <circle fill="#FFE1A4" cx="12" cy="14" r="1.2"/>
          <circle fill="#14243a" cx="9.9" cy="12.6" r=".6"/>
          <circle fill="#14243a" cx="14.1" cy="12.6" r=".6"/>
          <path fill="#F44542" d="M17.5 9h-11v-.8c0-3 2.5-5.5 5.5-5.5s5.5 2.5 5.5 5.5V9z"/>
          <path fill="#db3f3b" d="M17.9 9H6.1a.9.9 0 0 1-.8-.8c0-.5.4-.8.8-.8h11.6c.5 0 .8.4.8.8.1.5-.2.8-.6.8z"/>
        </svg>
      </div>

      <h1>About me</h1>

      <p>
        I'm a developer living in Flensburg, Germany. The purpose of this website is to present my projects and some thoughts. Here is a short curriculum vitae: </p>

      <p>
        I was born in Flensburg, Germany, in 1983.<br> After school I studied philosophy, psychology and German literature in Kiel, while working in IT-related jobs. After graduating as a
        <i title="That was the german equivalent to the Master of Arts degree, back then.">Magister Artium</i> with a thesis about
        <i title="To talk in the first person a lot">Egotism</i>, I was working as a teacher, biographer and lector. Then I decided I wanted to start learning something new again, so I returned to my old passion, the IT. I became a developer, focussing on frontend technologies. I love learning new things, so to this day I am very happy with my decision to make my living within a field in which new ideas and concepts emerge all the time. If you would like to see if I am suited for your project, please head over to the <router-link to="/developer">developer section</router-link>.
      </p>
      <p>
        You are welcome to get a more detailed look at my career on my
        <a href="https://www.xing.com/profile/Merten_Hanisch" target="_blank">Xing profile</a>! </p>
    </div>

    <div class="content-block">
      <h2>Other than that...</h2>

      <p>
        ... who doesn't like to do something different from time to time? Like </p>
      <ul>
        <li>
          <a href="http://mortal.host" target="_blank">Developing games</a>
        </li>
        <li>Getting away from technology and living in a
          <a href="http://valsgaard.de/">viking village</a> every now and then
        </li>
        <li>
          <a href="https://www.youtube.com/channel/UCqJToZ8hMUVA6Hrgl_jqfKA" target="_blank">Playing the
            concertina in dashing costumes</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'about'
  }
</script>

<style>
  .avatar {
    margin: 0 auto;
    max-width: 200px;
  }
  @keyframes colorFade {
    0% {
      fill: #59afe1;
    }
    25% {
      fill: var(--color-purple);
    }
    50% {
      fill: var(--color-yellow);
    }
    100% {
      fill: #59afe1;
    }

  }
  .avatar__bg {
    animation: colorFade;
    animation-delay: 2s;
    animation-duration: 20s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    fill: #59AFE1;
  }
</style>



// WEBPACK FOOTER //
// about.vue?faca9738